import { create } from "@mui/material/styles/createTransitions";
import { PENDING_APPROVAL, WAIT_LIST } from "../constants";
import { endPoints } from "../constants/urlConstants";
import { getCall } from "../services/apiService";
import {
  ProgramDetails,
  RegistrationApproval,
  UserData,
  userRegistration,
} from "../types/seatApproval";

interface ProgramPreference {
  name: string;
  id: string | number;
}

export const sortPreferences = (
  preferences: any[],
  grouped: boolean,
): ProgramPreference[] => {
  if (!preferences || preferences.length === 0) return [];

  return preferences
    .sort((a, b) => a.priorityOrder - b.priorityOrder)
    .map((pref) => {
      const program = grouped ? pref.preferredProgram : pref.preferredSession;
      return program
        ? {
            name: program.name || "",
            id: program.id || "",
          }
        : null;
    })
    .filter((program): program is ProgramPreference => program !== null);
};

export const mapApiDataToUserCards = (
  apiData: RegistrationApproval[],
  grouped?: boolean,
): UserData[] => {
  return apiData.map((item) => {
    const registration = item;
    console.log("registrationregistration", registration);
    const calculateAge = (dob: string | null): number => {
      if (!dob) return 25; // Default age
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    };
    const activeSwapRequest = registration.swapsRequests?.find(
      (request) => request.status === "active",
    );
    const swapRequestedPrograms =
      activeSwapRequest?.requestedPrograms?.map((program) => ({
        id: program.id,
        name: program.name,
      })) || [];

    const activeShiftRequest = registration.swapsRequests?.find(
      (request) => request.status === "active" && request.type === "can_shift",
    );

    console.log(registration, "apiData");

    const programPreferences = registration.preferences
      ? sortPreferences(registration.preferences, grouped)
      : [];
    console.log("programPreferences", programPreferences);
    console.log("regi", registration, registration.id);
    return {
      id: item.id,
      registrationId: registration.id,
      fullName: registration.fullName || `User ${registration.userId}`,
      gender: registration.gender || "other",
      age: calculateAge(registration.dob),
      totalPrograms: registration?.totalPrograms || 0,
      city: registration.city || null,
      profileImage: registration.profileUrl,
      approvalStatus: registration.approvals[0]?.approvalStatus || "pending",
      rating: registration.averageRating || null,
      lastActiveDate: new Date(
        new Date(registration?.createdAt).getTime() + 5.5 * 60 * 60 * 1000,
      ).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }),
      completedHDBs: registration?.noOfHDBs || 0,
      preferredRoomMate: registration.preferredRoomMate || "",
      programPreferences,
      emailAddress: registration.emailAddress || "",
      mobileNumber: registration.mobileNumber || "",
      isAssigned: false,
      assignedSession: undefined,
      swapRequests: swapRequestedPrograms || [],
      swapRequestId: activeSwapRequest?.id || null,
      shiftRequests:
        activeShiftRequest?.requestedPrograms.length > 0
          ? swapRequestedPrograms
          : null || [],
      shiftRequestId: activeSwapRequest?.id || null,
      allocatedProgram: registration.allocatedProgram || null,
      createdAt: registration.createdAt || "",
    };
  });
};

export const mapswapApiDataToUserCards = (
  apiData: RegistrationApproval[],
  grouped?: boolean,
): UserData[] => {
  return apiData.map((item) => {
    const registration = item.programRegistration;
    console.log("registrationss", item);
    const calculateAge = (dob: string | null): number => {
      if (!dob) return 25; // Default age
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    };

    console.log(registration, "apiData");

    const programPreferences = registration.preferences
      ? sortPreferences(registration.preferences, grouped)
      : [];
    console.log("programPreferences", {
      id: item.id,
      registrationId: registration.id,
      fullName: registration.fullName || `User ${registration.userId}`,
      gender: registration.gender || "other",
      age: calculateAge(registration.dob),
      totalPrograms: registration?.totalPrograms || 0,
      city: registration.city || null,
      profileImage: registration.profileUrl,
      approvalStatus: registration.approvals[0]?.approvalStatus || "pending",
      rating: registration.averageRating || null,
      lastActiveDate: new Date(
        new Date(registration?.createdAt).getTime() + 5.5 * 60 * 60 * 1000,
      ).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }),
      completedHDBs: registration?.noOfHDBs || 0,
      preferredRoomMate: registration.preferredRoomMate || "",
      programPreferences,
      emailAddress: registration.emailAddress || "",
      mobileNumber: registration.mobileNumber || "",
      isAssigned: false,
      assignedSession: undefined,
      swapRequests: registration.requestedPrograms || [],
      allocatedProgram: registration.allocatedProgram || null,
    });
    console.log("regi", registration, registration.id);
    return {
      id: item.id,
      registrationId: registration.id,
      fullName: registration.fullName || `User ${registration.userId}`,
      gender: registration.gender || "other",
      age: calculateAge(registration.dob),
      totalPrograms: registration?.totalPrograms || 0,
      city: registration.city || null,
      profileImage: registration.profileUrl,
      approvalStatus: registration.approvals[0]?.approvalStatus || "pending",
      rating: registration.averageRating || null,
      lastActiveDate: new Date(
        new Date(registration?.createdAt).getTime() + 5.5 * 60 * 60 * 1000,
      ).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }),
      completedHDBs: registration?.noOfHDBs || 0,
      preferredRoomMate: registration.preferredRoomMate || "",
      programPreferences,
      emailAddress: registration.emailAddress || "",
      mobileNumber: registration.mobileNumber || "",
      isAssigned: false,
      assignedSession: undefined,
      swapRequests: registration.requestedPrograms || [],
      allocatedProgram: registration.allocatedProgram || null,
      profileUrl: registration.profileUrl || "",
      createdAt: registration.createdAt || "",
    };
  });
};

export const fetchProgramsData = async (userId: string) => {
  try {
    const [programsResponse, registrationsResponse] = await Promise.all([
      getCall(endPoints.getProgramEndPoint({ status: "published" })), // list og published programs
      getCall(`registration`), //list of registrations for the user
    ]);

    return {
      programs: programsResponse.data.data.data,
      registrations: registrationsResponse.data.data.data,
    };
  } catch (error) {
    throw new Error("Failed to fetch program data");
  }
};

export const getStatusOfProgram = (
  programs: ProgramDetails[],
  registrations: userRegistration[],
) => {
  const programStatusMap: ProgramDetails[] = [];
  console.log("programs, registrations", programs, registrations);
  programs.map((program: ProgramDetails) => {
    const registration = registrations.find(
      (reg) => reg?.program?.id === program?.id && reg?.userId != null,
    );

    programStatusMap.push({
      ...program,
      statusMessage: registration
        ? getStatusMessage(program, registration)
        : undefined,
    });
  });
  console.log("programStatusMap", programStatusMap);
  return programStatusMap;
};
const getStatusMessage = (
  program: ProgramDetails,
  registration: userRegistration,
): string => {
  if (registration.registrationStatus === PENDING_APPROVAL) {
    return "Registered to program and awaiting for approval";
  } else if (
    program.limitedSeats &&
    registration.registrationStatus === WAIT_LIST
  ) {
    return "Registered to program and seat is waiting list";
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length === 0
  ) {
    return "Registered to program and payment pending";
  } else if (
    registration?.program.requiresPayment &&
    registration?.paymentDetails.length > 0
  ) {
    if (registration?.paymentDetails[0]?.status?.includes("online_pending")) {
      return "Registered to program and online payment pending";
    } else if (
      registration?.paymentDetails[0]?.status?.includes("offline_pending")
    ) {
      return "Registered to program and offline payment pending";
    } else if (registration?.paymentDetails[0]?.status?.includes("completed")) {
      return "Registered to program and payment completed";
    }
  } else if (
    registration?.program.isTravelInvolved &&
    registration?.travelInfo.length === 0
  ) {
    return "Registered to program and travel details pending";
  }
  return "Registered to program completed";
};

export const capitalize = (str: string) =>
  str
    ? str
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ")
    : "";

export const padNumber = (num: string | number) => {
  const n = Number(num);
  return isNaN(n) ? "-" : n < 10 ? `0${n}` : `${n}`;
};

export const formatGender = (gender: string) => {
  if (!gender) return "-";
  const g = gender.toLowerCase();
  if (g === "male" || g === "m") return "M";
  if (g === "female" || g === "f") return "F";
  return "-";
};
